import styled from 'styled-components';
import {Table} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const BorderedTable = styled(Table).attrs({
  className: 'table-bordered',
})`
  &&& {
    border-style: solid;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 5px;
    border-width: 1px;
    border-color: #9191b7;
  }
`;

export const Thead = styled.thead`
  &&& {
    background-color: transparent;
  }
`;

export const Tr = styled.tr`
  &&& {
    background-color: transparent;
  }
`;

export const Td = styled.td`
  text-align: left;
  height: 55px;
`;

export const Th = styled.th`
  text-align: left;
  background-color: ${({color}) => color};
  border-radius: ${({isFirst, isLast}) => isFirst ? '4px 0 0 0' : (isLast ? '0 4px 0 0' : '0')}
`;

export const PointerTh = styled.th`
  cursor: pointer;
  text-align: left;
  background-color: ${({color}) => color};
  border-radius: ${({isFirst, isLast}) => isFirst ? '4px 0 0 0' : (isLast ? '0 4px 0 0' : '0')}
`;

export const SortIcon = styled(FontAwesomeIcon)`
  margin-left: 10px;
`;

export const Flex = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const MargedDiv = styled.div`
  margin: 5px;
`;
